import React from 'react';
import img1 from './sarv-logo-blue.png'

const LogoSvg = () => (<img src={img1} alt='logo' width={"210px"} height={"44px"}/>)
export default LogoSvg;